import type { EntrySlice } from '../types'
import { isPersonEntry } from './guard'
import type { PersonEntry } from './meta'

/** What a person's edit dialog writes. `EditPersonDialog` is the form; it is not a feed edit form. */
export interface PersonDraft {
  title?: string
  category?: string
  birthday?: string | null
  contactFrequency?: string | null
  notes?: string | null
}

/**
 * The person kind's adapter behind the entry-kind seam.
 *
 * **Both surfaces are `null`, and that is the honest answer rather than a gap.** A person is an
 * entry — it lives in `doc.entries`, it carries metadata, it is searchable — but it does not appear
 * in the feed, so there is no row against the seven-arm `FeedEntry` union, and it is edited through
 * `EditPersonDialog` on the people page rather than inline in a row. What the registry buys for
 * this kind is the guard and totality: a kind with no slice would be a compile error, and a kind
 * whose surfaces are absent says so in one place instead of by omission from seven switches.
 */
export const personSlice: EntrySlice<PersonEntry, PersonDraft> = {
  guard: isPersonEntry,
  row: null,
  editForm: null,
}
